import React, { useState, createContext, useEffect } from "react";
import { useAuthUser } from "react-auth-kit";

export const SelectedLocationContext = createContext();

export const SelectedLocationProvider = ({ children }) => {
  const auth = useAuthUser();
  const user = auth();
  const locations = user?.locations;
  const locationIds = (locations || []).map((location) => location._id).join(",");
  const isAuthReady = Boolean(user);

  const [selectedLocation, setSelectedLocation] = useState(() => {
    const storedLocation = localStorage.getItem("selectedLocation");
    return storedLocation || locations?.[0]?._id || "";
  });

  useEffect(() => {
    const currentUser = auth();
    if (!currentUser) return;
    const currentLocations = currentUser.locations || [];
    if (!currentLocations.length) {
      setSelectedLocation("");
      return;
    }

    setSelectedLocation((current) => {
      if (current && currentLocations.some((location) => location._id === current)) return current;
      const storedLocation = localStorage.getItem("selectedLocation");
      if (storedLocation && currentLocations.some((location) => location._id === storedLocation)) {
        return storedLocation;
      }
      return currentLocations[0]._id;
    });
    // auth() is read inside so we always use the latest user; locationIds tracks location changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthReady, locationIds]);

  useEffect(() => {
    if (selectedLocation) {
      localStorage.setItem("selectedLocation", selectedLocation);
    } else {
      localStorage.removeItem("selectedLocation");
    }
  }, [selectedLocation]);

  return <SelectedLocationContext.Provider value={{ selectedLocation, setSelectedLocation }}>{children}</SelectedLocationContext.Provider>;
};
